import { externalLoginAction } from "@redux/actions";
import React from "react";
import { Button } from "react-bootstrap";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import { useDispatch } from "react-redux";

const LoginWithFacebook = () => {
  // state

  // variables

  // logics before hooks

  // hooks
  const dispatch = useDispatch();

  // logics
  const responseFacebook = (response) => {
    dispatch(externalLoginAction(["facebook", response.accessToken]));
  };

  // UI partials

  // effects

  // render
  return (
    <FacebookLogin
      appId="338764261769145"
      callback={responseFacebook}
      render={(renderProps) => (
        <Button variant="outline-info" onClick={renderProps.onClick}>
          <i className="bi bi-facebook mr-2" />
          Continue with Facebook
        </Button>
      )}
    />
  );
};

/* required: display name */
LoginWithFacebook.displayName = "LoginWithFacebook";

/* required: props types */
LoginWithFacebook.propTypes = {};

/* required: default props */
LoginWithFacebook.defaultProps = {};

export { LoginWithFacebook };
